import { Injectable } from '@angular/core';
import { ScriptLoaderService, StylesheetLoaderService } from 'ras-util';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { LocalDataCacheService } from '..';
import { DeferredConfigModel, InitialConfigModel } from '../../../core/models';
import { SessionTrackerService } from '../tracking/session-tracker.service';
import { StartUpConfigUiService } from './start-up-config-ui.service';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private sessionTrackingId: string;
  constructor(
    private startUpConfigUiService: StartUpConfigUiService,
    private sessionTrackerService: SessionTrackerService,
    private scriptLoaderService: ScriptLoaderService,
    private styleLoaderService: StylesheetLoaderService,
    private localDataStorage: LocalDataCacheService) { }

  public initSessionTracker(): void {

    this.startUpConfigUiService.sessionInfo$.pipe(take(1)).subscribe({
      next: (sessionInfo) => {
        if (sessionInfo && sessionInfo.isNewRastreatorSession) {
          this.sessionTrackerService.initSessionTracker().pipe(take(1)).subscribe();
        }
        if (sessionInfo)
          this.sessionTrackingId = sessionInfo.sessionTrackingId;
      }
    });
    this.addMobileTracking();
  }
  private addMobileTracking() {
    if (!this.localDataStorage.getSessionStorage().getItem("MobileTracking")) {
      if (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.maxTouchPoints > 1)) {
        this.localDataStorage.getSessionStorage().setItem("MobileTracking", "MobileTrackingDevice");
        this.sessionTrackerService.initMobileUserTracker("MobileTrackingDevice").pipe(take(1)).subscribe();
      }
    }
  }
  public loadDeferredFile(): void {
    forkJoin(
      this.startUpConfigUiService.initialConfig$.pipe(take(1)),
      this.startUpConfigUiService.deferredConfig$.pipe(take(1))
    ).subscribe(([initialConfig, defferedConfig]) => {
      //for performance purpose, loading additional scripts is delayed.
      setTimeout(() => {
        this.loadScripts(initialConfig, defferedConfig);
        this.loadStyles(initialConfig);
      }, 0);
    });
  }

  //Load 3rd party scripts
  private loadScripts(initialConfig: InitialConfigModel, defferedConfig: DeferredConfigModel): void {
    var isCookieBarVisible = (location.hostname.includes('seguros.es') || location.hostname.includes('segurostest.es')) ? true : (defferedConfig.isCookieBarVisible && !initialConfig.whiteLabel);
    if (isCookieBarVisible) {
        this.scriptLoaderService.load({
          name: 'cookie-consent',
          src: initialConfig.urlConfig.cookieConsentScriptUrl,
          deferred: true,
          asynchronous: true
        }).pipe(take(1)).subscribe(() => { });
      }
    this.scriptLoaderService.load({
      name: 'snap-engage',
      src: initialConfig.urlConfig.snapEngageScriptUrl,
      deferred: true,
      asynchronous: true
    }).pipe(take(1)).subscribe();
   
  }

  private loadStyles(config: InitialConfigModel): void {
    this.styleLoaderService.load({
      name: "cookie-consent",
      href: config.urlConfig.cookieConsentStyleUrl
    }).pipe(take(1)).subscribe();
  }
}
